import React from "react";
import { useQueryParam } from "use-query-params";

import { PageTabs } from "../../../components/ui/PageTabs";

import { ConectaPro } from "./conecta-pro";
import { SellerApp } from "./seller-app";
import { Checklist } from "./checklist";

import { WhatsappOficial } from "../WhatsappOficial";
import IntegracaoIfood from "../IntegracaoIfood";
import Integracao99Food from "../Integracao99Food";

const ABAS = [
  { value: "conecta-pro", label: "Conecta Pro" },
  { value: "app-vendedor", label: "App do Vendedor" },
  { value: "checklist", label: "Checklist" },
  { value: "api-whatsapp", label: "API WhatsApp" },
  { value: "ifood", label: "iFood" },
  { value: "99food", label: "99Food" },
];

function Conteudo({ aba }) {
  switch (aba) {
    case "app-vendedor":
      return <SellerApp />;
    case "checklist":
      return <Checklist />;
    case "api-whatsapp":
      return <WhatsappOficial />;
    case "ifood":
      return <IntegracaoIfood />;
    case "99food":
      return <Integracao99Food />;
    case "conecta-pro":
    default:
      return <ConectaPro />;
  }
}

export function Services() {
  const [aba, setAba] = useQueryParam("servico");
  const ativa = ABAS.some((item) => item.value === aba) ? aba : "conecta-pro";

  return (
    <div className="flex flex-col w-full">
      <PageTabs
        ariaLabel="Ativação de serviços"
        tabs={ABAS}
        value={ativa}
        onChange={setAba}
      />

      <div className="w-full pt-2">
        <Conteudo aba={ativa} />
      </div>
    </div>
  );
}

export default Services;
